export const translations = {
  uk: {
    // Personal Info
    name: 'Людмила Фісенко',
    
    // Navigation
    nav: {
      home: 'Головна',
      about: 'Про мене',
      specialization: 'Моя спеціалізація',
      testimonials: 'Відгуки',
      contact: 'Зв\'язатися зі мною'
    },
    
    // Hero Section
    hero: {
      title: 'Людмила Фісенко',
      subtitle: 'Психолог • Гештальт-терапевт • Сімейний терапевт',
      description: 'Я дипломований психолог з понад 10-річним досвідом практики. Допомагаю людям знайти внутрішні ресурси, пройти кризи та прийти до позитивних змін.',
      bookConsultation: 'Записатися на консультацію',
      learnMore: 'Дізнатися більше'
    },
    
    // About Section
    about: {
      title: 'Про мене',
      intro: 'Я дипломований психолог, сертифікований та акредитований гештальт-терапевт за стандартами Європейської асоціації гештальт-терапії (EAGT).',
      experience: 'Працюю як супервізор та веду терапевтичні групи. Навчалася у провідних тренерів та спеціалістів, пройшла всі три ступені довгострокової програми Українського Гештальт-інституту (2012–2024).',
      development: 'Постійно підвищую свою кваліфікацію: беру участь у спеціалізаціях, семінарах, конференціях, регулярно проходжу супервізію та особисту терапію (понад 300 годин). Суворо дотримуюся Етичного кодексу психолога.',
      stats: {
        years: 'Років практики',
        hours: 'Годин роботи щорічно',
        therapy: 'Годин особистої терапії'
      },
      formats: {
        title: 'Формати роботи',
        individual: '👤 Індивідуальні консультації',
        couples: '💑 Парна та подружня терапія',
        online: '💻 Онлайн-сесії',
        office: '🏢 Очні зустрічі в Празі',
        languages: '🗣️ Робота українською та російською мовами',
        duration: '⏱️ Короткострокова та довгострокова терапія'
      }
    },
    
    // Skills Section
    skills: {
      title: 'Мій підхід та спеціалізація',
      subtitle: 'Я працюю в парадигмі гештальт-терапії та екзистенційного підходу',
      specialization: {
        title: 'Моя спеціалізація',
        existential: 'Екзистенційна психотерапія',
        trauma: 'Робота з травмою та ПТСР',
        attachment: 'Терапія порушень прив\'язаності',
        clinical: 'Клінічний підхід у гештальт-терапії',
        crisis: 'Вікові кризи розвитку',
        sexology: 'Сексологія'
      },
      workWith: {
        title: 'З чим я працюю',
        identity: 'Пошук ідентичності та автентичності',
        personalCrisis: 'Особисті та вікові кризи',
        relationships: 'Стосунки з партнером',
        loss: 'Втрати та розставання',
        anxiety: 'Тривожність та страхи',
        family: 'Сімейні конфлікти'
      },
      methods: {
        title: 'Мої методи роботи',
        gestalt: 'Гештальт-терапія',
        existential: 'Екзистенційний підхід',
        dialogue: 'Терапевтичний діалог',
        emotions: 'Робота з почуттями та переживаннями',
        supervision: 'Супервізія та групова робота',
        ethics: 'Етичний підхід'
      }
    },
    
    // Testimonials
    testimonials: {
      title: 'Відгуки клієнтів',
      subtitle: 'Що кажуть люди, які пройшли терапію'
    },
    
    // Contact Section
    contact: {
      title: 'Зв\'яжіться зі мною',
      subtitle: 'Я готова допомогти вам у складних життєвих ситуаціях. Зв\'яжіться зі мною для запису на консультацію.',
      czechPhone: 'Телефон (Чехія)',
      ukrainePhone: 'Телефон (Україна)',
      location: 'Місцезнаходження',
      prague: 'Прага, Чехія',
      messengers: 'Зв\'язатися через месенджери',
      form: {
        name: 'Ім\'я',
        namePlaceholder: 'Ваше повне ім\'я',
        email: 'Email',
        emailPlaceholder: 'your.email@example.com',
        subject: 'Тема звернення',
        subjectPlaceholder: 'Коротко опишіть запит',
        message: 'Повідомлення',
        messagePlaceholder: 'Розкажіть про вашу ситуацію...',
        submit: 'Відправити повідомлення',
        sending: 'Надсилання…',
        successMessage: 'Дякую за ваше повідомлення! Я зв\'яжуся з вами найближчим часом.',
        errorMessage: 'Щось пішло не так. Спробуйте ще раз або зв\'яжіться через телефон/Telegram.'
      }
    },
    
    // Footer
    footer: {
      brand: 'Я дбайливо та акуратно підтримую своїх клієнтів у складних життєвих ситуаціях.',
      navigation: 'Навігація',
      services: {
        title: 'Мої послуги',
        individual: 'Індивідуальна терапія',
        couples: 'Парна терапія',
        online: 'Онлайн консультації',
        trauma: 'Робота з травмою'
      },
      connect: 'Зв\'язатися',
      rights: 'Всі права захищені.'
    }
  },
  
  ru: {
    // Personal Info
    name: 'Людмила Фисенко',
    
    // Navigation
    nav: {
      home: 'Главная',
      about: 'Обо мне',
      specialization: 'Моя специализация',
      testimonials: 'Отзывы',
      contact: 'Связаться со мной'
    },
    
    // Hero Section
    hero: {
      title: 'Людмила Фисенко',
      subtitle: 'Психолог • Гештальт-терапевт • Семейный терапевт',
      description: 'Я дипломированный психолог с более чем 10-летним опытом практики. Помогаю людям найти внутренние ресурсы, пройти кризисы и прийти к положительным изменениям.',
      bookConsultation: 'Записаться на консультацию',
      learnMore: 'Узнать больше'
    },
    
    // About Section
    about: {
      title: 'Обо мне',
      intro: 'Я дипломированный психолог, сертифицированный и аккредитованный гештальт-терапевт по стандартам Европейской ассоциации гештальт-терапии (EAGT).',
      experience: 'Работаю как супервизор и веду терапевтические группы. Обучалась у ведущих тренеров и специалистов, прошла все три ступени долгосрочной программы Украинского Гештальт-института (2012–2024).',
      development: 'Постоянно повышаю свою квалификацию: участвую в специализациях, семинарах, конференциях, регулярно прохожу супервизию и личную терапию (более 300 часов). Строго соблюдаю Этический кодекс психолога.',
      stats: {
        years: 'Лет практики',
        hours: 'Часов работы ежегодно',
        therapy: 'Часов личной терапии'
      },
      formats: {
        title: 'Форматы работы',
        individual: '👤 Индивидуальные консультации',
        couples: '💑 Парная и супружеская терапия',
        online: '💻 Онлайн-сессии',
        office: '🏢 Очные встречи в Праге',
        languages: '🗣️ Работа на русском и украинском языках',
        duration: '⏱️ Краткосрочная и долгосрочная терапия'
      }
    },
    
    // Skills Section
    skills: {
      title: 'Мой подход и специализация',
      subtitle: 'Я работаю в парадигме гештальт-терапии и экзистенциального подхода',
      specialization: {
        title: 'Моя специализация',
        existential: 'Экзистенциальная психотерапия',
        trauma: 'Работа с травмой и ПТСР',
        attachment: 'Терапия нарушений привязанности',
        clinical: 'Клинический подход в гештальт-терапии',
        crisis: 'Возрастные кризисы развития',
        sexology: 'Сексология'
      },
      workWith: {
        title: 'С чем я работаю',
        identity: 'Поиск идентичности и аутентичности',
        personalCrisis: 'Личные и возрастные кризисы',
        relationships: 'Отношения с партнёром',
        loss: 'Потери и расставания',
        anxiety: 'Тревожность и страхи',
        family: 'Семейные конфликты'
      },
      methods: {
        title: 'Мои методы работы',
        gestalt: 'Гештальт-терапия',
        existential: 'Экзистенциальный подход',
        dialogue: 'Терапевтический диалог',
        emotions: 'Работа с чувствами и переживаниями',
        supervision: 'Супервизия и групповая работа',
        ethics: 'Этический подход'
      }
    },
    
    // Testimonials
    testimonials: {
      title: 'Отзывы клиентов',
      subtitle: 'Что говорят люди, которые прошли терапию'
    },
    
    // Contact Section
    contact: {
      title: 'Свяжитесь со мной',
      subtitle: 'Я готова помочь вам в сложных жизненных ситуациях. Свяжитесь со мной для записи на консультацию.',
      czechPhone: 'Телефон (Чехия)',
      ukrainePhone: 'Телефон (Украина)',
      location: 'Местоположение',
      prague: 'Прага, Чехия',
      messengers: 'Связаться через мессенджеры',
      form: {
        name: 'Имя',
        namePlaceholder: 'Ваше полное имя',
        email: 'Email',
        emailPlaceholder: 'your.email@example.com',
        subject: 'Тема обращения',
        subjectPlaceholder: 'Кратко опишите запрос',
        message: 'Сообщение',
        messagePlaceholder: 'Расскажите о вашей ситуации...',
        submit: 'Отправить сообщение',
        sending: 'Отправка…',
        successMessage: 'Спасибо за ваше сообщение! Я свяжусь с вами в ближайшее время.',
        errorMessage: 'Что-то пошло не так. Попробуйте снова или свяжитесь по телефону/Telegram.'
      }
    },
    
    // Footer
    footer: {
      brand: 'Я бережно и аккуратно поддерживаю своих клиентов в сложных жизненных ситуациях.',
      navigation: 'Навигация',
      services: {
        title: 'Мои услуги',
        individual: 'Индивидуальная терапия',
        couples: 'Парная терапия',
        online: 'Онлайн консультации',
        trauma: 'Работа с травмой'
      },
      connect: 'Связаться',
      rights: 'Все права защищены.'
    }
  },
  
  cs: {
    // Personal Info
    name: 'Ludmila Fisenková',
    
    // Navigation
    nav: {
      home: 'Domů',
      about: 'O mně',
      specialization: 'Specializace',
      testimonials: 'Reference',
      contact: 'Kontakt'
    },
    
    // Hero Section
    hero: {
      title: 'Ludmila Fisenková',
      subtitle: 'Psycholog • Gestalt terapeut • Rodinný terapeut',
      description: 'Jsem diplomovaný psycholog s více než 10letou praxí v Praze.',
      notice: 'Pracuji pouze s klienty v ukrajinštině a ruštině. Pro podrobné informace o mých službách a objednání konzultace prosím přejděte na ukrajinskou verzi webu.',
      bookConsultation: 'Přejít na ukrajinskou verzi',
      learnMore: 'Kontaktovat v ukrajinštině'
    },
    
    // About Section
    about: {
      title: 'O mně',
      intro: 'Jsem diplomovaný psycholog a certifikovaný gestalt terapeut podle standardů Evropské asociace gestalt terapie (EAGT).',
      experience: 'Pracuji více než 10 let jako psycholog a terapeut. Specializuji se na gestalt terapii a existenciální přístup.',
      development: 'Pro podrobné informace o mé kvalifikaci a specializaci navštivte prosím ukrajinskou verzi webu.',
      stats: {
        years: 'Let praxe',
        hours: 'Hodin práce ročně',
        therapy: 'Hodin osobní terapie'
      },
      formats: {
        title: 'Formáty práce',
        individual: '👤 Individuální konzultace',
        couples: '💑 Párová terapie',
        online: '💻 Online sezení',
        office: '🏢 Osobní setkání v Praze',
        languages: '🗣️ Práce v ukrajinštině a ruštině',
        duration: '⏱️ Krátkodobá i dlouhodobá terapie'
      }
    },
    
    // Skills Section
    skills: {
      title: 'Můj přístup',
      subtitle: 'Pracuji v paradigmatu gestalt terapie a existenciálního přístupu',
      specialization: {
        title: 'Specializace',
        existential: 'Existenciální psychoterapie',
        trauma: 'Práce s traumatem',
        attachment: 'Terapie poruch připoutání',
        clinical: 'Klinický přístup',
        crisis: 'Věkové krize',
        sexology: 'Sexuologie'
      },
      workWith: {
        title: 'S čím pracuji',
        identity: 'Hledání identity',
        personalCrisis: 'Osobní krize',
        relationships: 'Vztahy s partnerem',
        loss: 'Ztráty a rozchody',
        anxiety: 'Úzkost a strachy',
        family: 'Rodinné konflikty'
      },
      methods: {
        title: 'Metody práce',
        gestalt: 'Gestalt terapie',
        existential: 'Existenciální přístup',
        dialogue: 'Terapeutický dialog',
        emotions: 'Práce s emocemi',
        supervision: 'Supervize',
        ethics: 'Etický přístup'
      }
    },
    
    // Testimonials
    testimonials: {
      title: 'Reference klientů',
      subtitle: 'Co říkají lidé, kteří prošli terapií'
    },
    
    // Contact Section
    contact: {
      title: 'Kontakt',
      subtitle: 'Jsem připravena vám pomoci v obtížných životních situacích. Kontaktujte mě pro objednání konzultace.',
      czechPhone: 'Telefon (Česká republika)',
      ukrainePhone: 'Telefon (Ukrajina)',
      location: 'Lokalita',
      prague: 'Praha, Česká republika',
      messengers: 'Kontakt přes messengery',
      form: {
        name: 'Jméno',
        namePlaceholder: 'Vaše celé jméno',
        email: 'Email',
        emailPlaceholder: 'vas.email@example.com',
        subject: 'Předmět',
        subjectPlaceholder: 'Stručně popište váš dotaz',
        message: 'Zpráva',
        messagePlaceholder: 'Popište vaši situaci...',
        submit: 'Odeslat zprávu',
        sending: 'Odesílám…',
        successMessage: 'Děkuji za vaši zprávu! Brzy se vám ozvu.',
        errorMessage: 'Něco se pokazilo. Zkuste to znovu nebo nás kontaktujte telefonem/Telegramem.'
      }
    },
    
    // Footer
    footer: {
      brand: 'Pečlivě a citlivě podporuji své klienty v obtížných životních situacích.',
      navigation: 'Navigace',
      services: {
        title: 'Služby',
        individual: 'Individuální terapie',
        couples: 'Párová terapie',
        online: 'Online konzultace',
        trauma: 'Práce s traumatem'
      },
      connect: 'Kontakt',
      rights: 'Všechna práva vyhrazena.'
    }
  },
  
  en: {
    // Personal Info
    name: 'Ludmila Fisenko',
    
    // Navigation
    nav: {
      home: 'Home',
      about: 'About',
      specialization: 'Specialization',
      testimonials: 'Testimonials',
      contact: 'Contact'
    },
    
    // Hero Section
    hero: {
      title: 'Ludmila Fisenko',
      subtitle: 'Psychologist • Gestalt Therapist • Family Therapist',
      description: 'I am a licensed psychologist with over 10 years of practice in Prague.',
      notice: 'I work only with clients in Ukrainian and Russian languages. For detailed information about my services and to book a consultation, please visit the Ukrainian version of the website.',
      bookConsultation: 'Go to Ukrainian version',
      learnMore: 'Contact in Ukrainian'
    },
    
    // About Section
    about: {
      title: 'About Me',
      intro: 'I am a licensed psychologist and certified gestalt therapist according to European Association for Gestalt Therapy (EAGT) standards.',
      experience: 'I work as a supervisor and lead therapeutic groups. I have over 10 years of experience in psychology and therapy.',
      development: 'For detailed information about my qualifications and specialization, please visit the Ukrainian version of the website.',
      stats: {
        years: 'Years of Practice',
        hours: 'Hours of Work Annually',
        therapy: 'Hours of Personal Therapy'
      },
      formats: {
        title: 'Work Formats',
        individual: '👤 Individual consultations',
        couples: '💑 Couples therapy',
        online: '💻 Online sessions',
        office: '🏢 In-person meetings in Prague',
        languages: '🗣️ Work in Ukrainian and Russian',
        duration: '⏱️ Short-term and long-term therapy'
      }
    },
    
    // Skills Section
    skills: {
      title: 'My Approach',
      subtitle: 'I work within the paradigm of gestalt therapy and existential approach',
      specialization: {
        title: 'Specialization',
        existential: 'Existential psychotherapy',
        trauma: 'Trauma work',
        attachment: 'Attachment disorders therapy',
        clinical: 'Clinical approach',
        crisis: 'Age-related crises',
        sexology: 'Sexology'
      },
      workWith: {
        title: 'What I Work With',
        identity: 'Identity search',
        personalCrisis: 'Personal crises',
        relationships: 'Partner relationships',
        loss: 'Loss and separation',
        anxiety: 'Anxiety and fears',
        family: 'Family conflicts'
      },
      methods: {
        title: 'Work Methods',
        gestalt: 'Gestalt therapy',
        existential: 'Existential approach',
        dialogue: 'Therapeutic dialogue',
        emotions: 'Working with emotions',
        supervision: 'Supervision',
        ethics: 'Ethical approach'
      }
    },
    
    // Testimonials
    testimonials: {
      title: 'Client Testimonials',
      subtitle: 'What people who have undergone therapy say'
    },
    
    // Contact Section
    contact: {
      title: 'Contact Me',
      subtitle: 'I am ready to help you in difficult life situations. Contact me to book a consultation.',
      czechPhone: 'Phone (Czech Republic)',
      ukrainePhone: 'Phone (Ukraine)',
      location: 'Location',
      prague: 'Prague, Czech Republic',
      messengers: 'Contact via messengers',
      form: {
        name: 'Name',
        namePlaceholder: 'Your full name',
        email: 'Email',
        emailPlaceholder: 'your.email@example.com',
        subject: 'Subject',
        subjectPlaceholder: 'Briefly describe your inquiry',
        message: 'Message',
        messagePlaceholder: 'Describe your situation...',
        submit: 'Send Message',
        sending: 'Sending…',
        successMessage: 'Thank you for your message! I will contact you soon.',
        errorMessage: 'Something went wrong. Please try again or contact us via phone/Telegram.'
      }
    },
    
    // Footer
    footer: {
      brand: 'I carefully and gently support my clients in difficult life situations.',
      navigation: 'Navigation',
      services: {
        title: 'Services',
        individual: 'Individual therapy',
        couples: 'Couples therapy',
        online: 'Online consultations',
        trauma: 'Trauma work'
      },
      connect: 'Connect',
      rights: 'All rights reserved.'
    }
  }
};
